import { graphql } from '@/gql/graphql';

export const OrganizationDetailToolbarFragment = graphql(/* GraphQL */ `
  fragment OrganizationDetailToolbar on event {
    id
    title
    owner_id
    permissions
    ... on event @_optional {
      event_people(limit: 1, where: { person_id: { _eq: $personId } }) {
        event_id
        person_id
      }
    }
  }
`);
